import Vue from 'vue'

// 创建事件总线实例
const eventBus = new Vue()

export default eventBus 